import React, { useContext, useEffect, useState } from 'react';
import classNames from 'classnames';
import axios from 'axios';

import ChatroomSvg from '../svg/chatroomSvg';
import { Scrollbars } from 'react-custom-scrollbars';
import {DataContext} from '../context/DataContext';
import {AuthContext} from '../context/AuthContext';
import loadingSpin from '../images/loadingSpin.gif';
import { useHistory } from 'react-router-dom';

const navItems = [
  {
    label: 'Agricultural JSS 2 A 2019/2020',
    newChat: '2',
    current: true
  },
  {
    label: 'Basic Technology Exam',
    newChat: '5'
  },
  {
    label: 'Business Studies Exam',
    condition: 'retake',
  },
  {
    label: 'Basic Science and Technology Exam',
    condition: 'retake',
  },
  {
    label: 'Mathematics CA',
    condition: 'completed',
  },
  {
    label: 'Basic Science and Technology First CA ',
    condition: 'completed',
  },
  {
    label: 'Computer Studies First CA',
    condition: 'completed',
  },
  {
    label: 'English Language First CA',
    condition: 'completed',
  },
  {
    label: 'Computer Studies Second CA',
    condition: 'completed',
  },
  {
    label: 'Basic Technology Exam',
    condition: 'completed',
  }
];

const ChatroomSidebar = () => {
  const history = useHistory();
  const authContext = useContext(AuthContext);
  const dataContext = useContext(DataContext);
  const toggleMobileChat = authContext.toggleMobileChat;
  const [ groups, setGroups] = useState([]);
  const [newChat, setNewChat] = useState({});
  const [count, setCount] = useState(0);
  const [msgCount, setMsgCount] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('')

  const studentInfo = JSON.parse(localStorage.getItem('studentInfo'));
  const studentId = studentInfo[0].studentId;
  const schoolDomain = localStorage.getItem('schoolDomain');
  const LSgroups = JSON.parse(localStorage.getItem('chatGroups'));

  useEffect(() => {
    console.log(groups)
    const getGroups = async () => {
      try {
          setLoading(true);
          const { data } = await axios.get(`${authContext.baseUrl}/student/groups/${schoolDomain}/${studentId}`);
          console.log(data);
          const groups = data.data
          if(data.status) {
            setLoading(false);
            setGroups(groups);
          } else {
            setLoading(false);
            setErrorMessage(data.message);
          }
      } catch (error) {
          console.log('fetch messages error', error);
          setLoading(false);
          setErrorMessage('Unable to fetch groups');
      }
    };
    LSgroups ? setGroups(LSgroups) : getGroups();
    return () => null
  }, [setGroups]);

  const handleClickedGroup = (group) => {
    dataContext.setClickedGroupId(group.groupId);
    dataContext.setGroupName(group.groupname);
    authContext.setToggleMobileChat(!toggleMobileChat)
    setCount(0);
    console.log(window.innerWidth, 'clicked>>>>>')
    // if (window.innerWidth < '640') {
    //   history.push('/chatroom')
    //   console.log(window.innerWidth)
    // }

    const getChats = async () => {
      try {
          const { data } = await axios.get(`${authContext.baseUrl}/student/chathistory/${schoolDomain}/${studentId}?groupId=${group.groupId}`);
          // dataContext.setChats(data.data)
          const groupId = group.groupId;
          dataContext.setChats( chats => {
            if(chats.find(chat => chat.groupId === groupId)) {
              return chats.map(chat => chat.groupId === groupId ? {...chat, chats: data.data} : chat )
              // return chats.map(chat => chat.groupId === groupId ? [...chat, {groupId, chats: data.data}] : chat )
            } else {
              return [...chats, {groupId, chats: data.data}]
            }
            // return chats.map(chat => chat.groupId === groupId ? chat : [...chats, {groupId, chats: data.data}] )
          })
          console.log(data.data)
      } catch (error) {
          console.log('fetch messages error', error)
      }
    };
    getChats();

    setMsgCount(msgCount => {
      return msgCount.map(each => each.groupId === group.groupId ? {...each, count: 0 } : each)
    });
    console.log(msgCount)
  };

  // function reArrangeGroupList( old_array, old_index, new_index ){

  //   return old_array.map(( item, index, array ) => {
  //     if( index === old_index ) return array[ new_index ];
  //     else if( index === new_index ) return array[ old_index ]; 07030881664
  //     else return item;
  //   });
  
  // };

  function reArrangeGroupList(array, from, to) {
    if( to === from ) return array;
  
    let target = array[from];                         
    let increment = to < from ? -1 : 1;
  
    for(let k = from; k != to; k += increment){
      array[k] = array[k + increment];
    }
    array[to] = target;
    return array;
  }

  useEffect(() => {
    const messageFromBackEnd = dataContext.messageFromBackEnd
    const configNewMsgCount = {
      groupId : messageFromBackEnd.groupId,
      count : 1
    }
    console.log('groups', groups, messageFromBackEnd);
    setNewChat(messageFromBackEnd);
    // messageFromBackEnd.groupId !== undefined && window.innerWidth > '640' &&
    messageFromBackEnd.groupId !== undefined && groups.length > 1 &&
    setMsgCount(msgCount => {
      const found = msgCount.filter(item => item.groupId === messageFromBackEnd.groupId)[0];
      const newChatInGroupListIdx = groups.filter(item => item.groupId === messageFromBackEnd.groupId)[0]
      const foundIndex = groups && groups.indexOf(newChatInGroupListIdx);
      groups && setGroups(reArrangeGroupList(groups, foundIndex, 0)); 
        if (found) {
          return msgCount.map(each => each.groupId === messageFromBackEnd.groupId ? {...each, count: found.count++ } : each)
        } else {
        return [...msgCount, configNewMsgCount]
      };
    });
  }, []);

  console.log('chatGroups', groups)

  const NavItem = ({ group }) => {
    // console.log(newChat.groupId)
    // console.log(msgCount.filter(item => item.groupId === group.groupId));

    const chatCount = msgCount.filter(item => item.groupId === group.groupId)[0]

    const showChatCount = () => {
      const found = msgCount.filter(item => item.groupId === group.groupId)[0];
      return found ? found.count : ''
    }

    const classes = classNames({
      'leading-none text-xs leading-4 font-medium w-full border-b border-gray-600 cursor-pointer': true,
      'text-blue-100': dataContext.clickedGroupId === group.groupId
    });

    const alert = classNames({
      'w-5 h-5 border-0 flex justify-center items-center text-white  rounded-full' : true,
      'border-0 bg-blue-100' : msgCount.length > 0 && msgCount.length !== undefined ? chatCount && chatCount.count > 0 : false
      // 'border-0 bg-blue-100' : newChat.groupId === group.groupId && newChat.userName !== 'You'
    });

    return (
      <div onClick={()=> handleClickedGroup(group)} className={classes}>
        <div className="flex justify-between items-center py-4 z-0 ">
          <div className="mr-2">
            <ChatroomSvg />
          </div>
          <span className="mr-2 flex-grow truncate">
            {group.groupname}
          </span>
          <div className='flex justify-self-end'>
              <span className={alert}> {msgCount.length > 0 ? showChatCount() : ''} </span>
          </div>
        </div>
      </div>
    );
  };

  const NavItemContainer = ({ children }) => (
    <div>{children}</div>
  );

  

  return (
    <>
      <div  className='hidden sm:block h-full'>
        <Scrollbars autoHide style={{ height: 450 }}>
          <section className="w-full h-full mt-4 z-0">
            <div className="-mt-1 mx-0 w-full">
              {groups.length ? groups.map((group, index) => (
                <NavItemContainer key={index}>
                  <NavItem group={group} />
                </NavItemContainer>
              )) : 
              <>
              { loading ? 
                <div className='block w-full h-full my-24 mx-auto'>
                    <img src={loadingSpin} className='mx-auto' alt='loading...' />
                </div> :
                <span className='text-sm text-red-200 mt-8'>
                  {errorMessage}
                </span>
              }
              </>
              }
            </div>
          </section>
        </Scrollbars>
      </div>

      {/* Mobile Screens */}
        <section className="block sm:hidden px-6 sm:px-0 w-full mt-4 z-0">
          <div className="-mt-1 mx-0">
            {groups.length ? groups.map((group, index) => (
              <>
                <NavItemContainer key={index}>
                  <NavItem group={group} />
                </NavItemContainer>
              </>
            )) : 
            <>
              { loading ? 
                <div className='block w-full h-full my-24 mx-auto'>
                    <img src={loadingSpin} className='mx-auto' alt='loading...' />
                </div> :
                <span className='text-sm text-red-200 mt-8'>
                  {errorMessage}
                </span>
              }
            </>
            }
          </div>
        </section>
    </>
  );
};

// 

export default ChatroomSidebar;
